import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { PatientServicesEnum } from "./PatientServices.schema"
import { orderDeliveryServicesConf } from "./referential/orderDeliveryService.referential"

type Conf = typeof config
const config = { disabled: true }

const orderConf = () => {
  return Object.keys(orderDeliveryServicesConf).reduce<Record<string, Conf>>(
    (res, name) => {
      res[`${PatientServicesEnum.ORDER_DELIVERY_SERVICES}.${name}`] = config
      return res
    },
    {},
  )
}

const adhTeamConf = {
  ...orderConf(),
  [PatientServicesEnum.HAS_PRESCRIPTION_SCANNER]: config,
  [PatientServicesEnum.HEALTH_APPOINTMENT_URL]: config,
} as const

export const formRoleConf = {
  [ROLES.ADMIN]: {},
  [ROLES.ADHERENT_HOLDER]: {},
  [ROLES.ADHERENT_TEAM]: adhTeamConf,
} satisfies RoleStrategy<Record<string, Conf>>
